import { render, staticRenderFns } from "./IOSSwitch.vue?vue&type=template&id=3e9088bf&scoped=true"
import script from "./IOSSwitch.vue?vue&type=script&lang=js"
export * from "./IOSSwitch.vue?vue&type=script&lang=js"
import style0 from "./IOSSwitch.scss?vue&type=style&index=0&id=3e9088bf&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9088bf",
  null
  
)

export default component.exports